var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { jsx as _jsx } from "react/jsx-runtime";
import { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import InternalTools from "..";
import { useHistory, useLocation } from "react-router-dom";
import MapCollectionDetails from "../../mapCollectionDetails/MapCollectionDetails";
import { getCollectionMeta, getMapOrderDetails, } from "../../../api/internalTools";
import { setMapCollectionDetailsSearchText, setIsSortClicked, setSearchClicked, setMapCollectionDetailsSortText, } from "../../../store/reducers/venuesSlice";
import { INDOOR_MAP } from "../../../store/common/constants";
import indoorHelper from "../../../store/helpers/indoorHelper";
import _ from "lodash";
var InternalToolsComponent = function () {
    var dispatch = useDispatch();
    var history = useHistory();
    var location = useLocation();
    var locationState = location.state;
    var isMapCollection = locationState === null || locationState === void 0 ? void 0 : locationState.isMapCollectionDetails;
    var token = useSelector(function (state) { return state === null || state === void 0 ? void 0 : state.user.token; });
    var collectionMetaList = useSelector(function (state) { return state === null || state === void 0 ? void 0 : state.app.collectionMetaList; });
    var collectionTabList = useSelector(function (state) { return state === null || state === void 0 ? void 0 : state.overview.collectionTabList; });
    var mapInCollectionList = useSelector(function (state) { return state === null || state === void 0 ? void 0 : state.app.mapInCollectionList; });
    var isSearchClicked = useSelector(function (state) { return state === null || state === void 0 ? void 0 : state.venues.isSearchClicked; });
    var isSortClicked = useSelector(function (state) { return state === null || state === void 0 ? void 0 : state.venues.isSortClicked; });
    var mapCollectionDetailsSearchText = useSelector(function (state) {
        return state === null || state === void 0 ? void 0 : state.venues.mapCollectionDetailsSearchText;
    });
    var mapCollectionDetailsSortText = useSelector(function (state) {
        return state === null || state === void 0 ? void 0 : state.venues.mapCollectionDetailsSortText;
    });
    var _a = useState(mapInCollectionList), mapsInCollectionState = _a[0], setMapsInCollectionState = _a[1];
    useEffect(function () {
        history.push({
            pathname: "/internalTools",
            search: window.location.search,
        });
        if (token && collectionTabList) {
            dispatch(getCollectionMeta());
            dispatch(getMapOrderDetails());
        }
    }, [collectionTabList, token, dispatch]);
    var searchMapsFromList = function (listViewSearchInput, listViewSortInput, setMapsInCollectionState) {
        return function (dispatch) { return __awaiter(void 0, void 0, void 0, function () {
            var venuesListData, search, filteredSearchedMap, response, searchedMaps;
            return __generator(this, function (_a) {
                venuesListData = mapInCollectionList === null || mapInCollectionList === void 0 ? void 0 : mapInCollectionList.maps;
                search = listViewSearchInput === null || listViewSearchInput === void 0 ? void 0 : listViewSearchInput.trim().toLowerCase();
                dispatch(setSearchClicked(null));
                filteredSearchedMap = venuesListData ? venuesListData : [];
                if (listViewSearchInput !== "") {
                    filteredSearchedMap = _.filter(venuesListData, function (obj) {
                        return _.some(INDOOR_MAP.SEARCH_FIELD_MAPCOLLECTION, function (searchField) {
                            var searchElement = indoorHelper.getPropertyValueByString(searchField, obj);
                            var searchedTrimElement = searchElement && searchElement.toString().trim();
                            return (searchedTrimElement &&
                                searchedTrimElement.toLowerCase().includes(search));
                        });
                    });
                }
                response = filteredSearchedMap;
                if (listViewSortInput !== "") {
                    if (listViewSortInput === "mapName") {
                        response = _.orderBy(filteredSearchedMap, "mapName", ["asc"]);
                    }
                    else {
                        response = _.orderBy(filteredSearchedMap, "mapcity", ["asc"]);
                    }
                }
                searchedMaps = __assign(__assign({}, mapInCollectionList), { maps: response });
                setMapsInCollectionState(searchedMaps);
                return [2 /*return*/];
            });
        }); };
    };
    useEffect(function () {
        if ((isSearchClicked &&
            (mapCollectionDetailsSearchText ||
                mapCollectionDetailsSearchText === "")) ||
            (isSortClicked && mapCollectionDetailsSortText)) {
            dispatch(searchMapsFromList(mapCollectionDetailsSearchText, mapCollectionDetailsSortText, setMapsInCollectionState));
        }
    }, [
        isSearchClicked,
        mapCollectionDetailsSearchText,
        mapCollectionDetailsSortText,
        isSortClicked,
    ]);
    useEffect(function () {
        // if search text is not blank then initially set it blank
        mapCollectionDetailsSearchText !== "" &&
            dispatch(setMapCollectionDetailsSearchText({
                isSearchClicked: false,
                mapCollectionDetailsSearchText: "",
            }));
        // if sort text is not modified then initially set it modified
        mapCollectionDetailsSortText !== "mapName" &&
            dispatch(setMapCollectionDetailsSortText({
                mapCollectionDetailsSortText: "mapName",
                isSortClicked: false,
            }));
        return function () {
            // when unmounting search and sort click needs to be false so that it will not go in searching block on initial load of tab
            setIsSortClicked(false);
            setSearchClicked(false);
        };
    }, []);
    return isMapCollection ? (_jsx(MapCollectionDetails
    //mapDetailsList={mapInCollectionList}
    , { 
        //mapDetailsList={mapInCollectionList}
        mapDetailsList: mapsInCollectionState, onSearchChange: function (searchText) {
            dispatch(setMapCollectionDetailsSearchText({
                isSearchClicked: true,
                mapCollectionDetailsSearchText: searchText,
            }));
        }, onSortChange: function (sortText) {
            return dispatch(setMapCollectionDetailsSortText({
                mapCollectionDetailsSortText: sortText,
                isSortClicked: true,
            }));
        }, searchText: mapCollectionDetailsSearchText, sortText: mapCollectionDetailsSortText })) : (_jsx(InternalTools, { collectionMetaList: collectionMetaList }));
};
export default InternalToolsComponent;
